<p-card *ngIf="!singleVenueView">
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="creditPlatformVenues"
		dataKey="key"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[globalFilterFields]="['name', 'key']"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex p-grid">
				<div class="p-col-12 p-md-3">
					<h2>Credit Processing Status</h2>
				</div>
				<div class="p-col-12 p-md-3">
					<div class="d-flex flex-column"></div>
				</div>
				<div class="p-col-12 p-md-3">
					<span class="p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
							placeholder="Global Search"
						/>
					</span>
				</div>
				<div class="p-col-12 p-md-3">
					<div class="d-flex flex-column">
						<p-dropdown
							*ngIf="creditPlatforms"
							placeholder="Select Credit Platform"
							[options]="creditPlatforms"
							optionLabel="label"
							optionValue="value"
							name="creditPlatforms"
							(onChange)="changePlatform()"
							[(ngModel)]="creditPlatformSelected"
							[style]="{ width: '100%' }"
							styleClass="m-2"
							appendTo="body"
						></p-dropdown>
					</div>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header" #header>
			<tr>
				<th pSortableColumn="name">
					Name
					<p-sortIcon field="name"></p-sortIcon>
				</th>
				<th pSortableColumn="key">
					Venue Key
					<p-sortIcon field="key"></p-sortIcon>
				</th>
				<th pSortableColumn="VenueCreditStatus.status">
					Status
					<p-sortIcon field="VenueCreditStatus.status"></p-sortIcon>
				</th>
				<th pSortableColumn="VenueCreditStatus.offlineDateTime">
					Offline Date
					<p-sortIcon field="VenueCreditStatus.offlineDateTimeitCount"></p-sortIcon>
				</th>
				<th></th>
			</tr>
		</ng-template>
		<ng-template pTemplate="body" #body let-rec let-idx="index">
			<tr>
				<td>
					<span class="p-column-title">Name</span>
					{{ rec.name }}
				</td>
				<td>
					<span class="p-column-title">Venue Key</span>
					{{ rec.key }}
				</td>
				<td>
					<span class="p-column-title">Status</span>
					<fa-icon *ngIf="!rec.VenueCreditStatus?.status" [icon]="['far', 'wifi-slash']" size="2x"></fa-icon>
					<fa-icon *ngIf="rec.VenueCreditStatus?.status" [icon]="['far', 'wifi']" size="2x"></fa-icon>
				</td>
				<td>
					<span class="p-column-title">Offline Date</span>
					<span *ngIf="rec.VenueCreditStatus?.offlineDateTime">
						{{ moment(rec.VenueCreditStatus?.offlineDateTime).format("l LT") }}
					</span>
				</td>
				<td>
					<div>
						<p-button
							*ngIf="rec.VenueCreditStatus.status"
							pRipple
							styleClass="p-button p-button-raised p-button-danger m-2"
							(click)="toggleStateConfirm(rec, false)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'power-off']" size="lg" class="ms-1"></fa-icon>
							</ng-template>
						</p-button>
						<p-button
							*ngIf="!rec.VenueCreditStatus.status"
							pRipple
							styleClass="p-button p-button-raised p-button-success m-2"
							(click)="toggleStateConfirm(rec, true)"
						>
							<ng-template pTemplate="content">
								<fa-icon [icon]="['far', 'power-off']" size="lg" class="ms-1"></fa-icon>
							</ng-template>
						</p-button>
					</div>
				</td>
			</tr>
		</ng-template>
	</p-table>
</p-card>
